export default __webpack_public_path__ + "static/media/EEFF-2019-para-pantalla.29760eda.webp";